
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billboard",
      function () {
        return require("private-next-pages/billboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/billboard"])
      });
    }
  